import React from 'react';

const AnimatedButton = ({
  children,
  className = '',
  variant = 'primary',
  size = 'medium',
  as: Component = 'button',
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return 'bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white';
      case 'secondary':
        return 'bg-gradient-to-r from-accent-500 to-accent-600 hover:from-accent-600 hover:to-accent-700 text-white';
      case 'outline':
        return 'border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white';
      case 'ghost':
        return 'bg-white text-darkBlue-900 border border-gray-200 hover:bg-gray-100';
      case 'glass':
        return 'bg-white text-darkBlue-900 border border-gray-200 hover:bg-gray-100';
      default:
        return 'bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white';
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return 'px-4 py-2 text-readable-sm';
      case 'large':
        return 'px-8 py-4 text-readable-lg';
      case 'xl':
        return 'px-10 py-5 text-readable-xl';
      default:
        return 'px-6 py-3 text-readable-base';
    }
  };

  return (
    <Component
      className={`rounded-lg font-semibold transition-all duration-200 hover:scale-105 active:scale-95 shadow-md hover:shadow-lg ${getVariantStyles()} ${getSizeStyles()} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default AnimatedButton;
